import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279 } from '~/src/styles/tokens/break-points';

export const Skeleton = styled.div<{ isImage?: boolean; height?: number; marginTop?: number; }>`
    width: ${p => p.isImage ? rem(300) : '100%'};
    height: ${(p) => (p.height ? rem(p.height) : 'auto')};
    overflow: ${p => p.isImage ? 'unset' : 'hidden'};
    align-items: ${(p) => (p.isImage ? 'center' : 'flex-start')};
    margin-top: ${(p) => (p.marginTop ? rem(p.marginTop) : 'unset')};

    ${(p) =>
        p.isImage &&
        css`
            ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            display: none;
        `,
    )}`};
`;

export const ButtonSkeleton = styled.div<{ width?: number; height?: number; }>`
    width: ${(p) => (p.width ? rem(p.width) : '100%')};
    height: ${(p) => (p.height ? rem(p.height) : '100%')};

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            width: 100%;
        `,
    )};
`;
